export const getUserPhoneNumber = `query getUser{
  getUser{
      phone
  }
}`;
